import { render, staticRenderFns } from "./IncomeStatement.vue?vue&type=template&id=8c8b45e0"
import script from "./IncomeStatement.vue?vue&type=script&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&lang=js"
import style0 from "./IncomeStatement.vue?vue&type=style&index=0&id=8c8b45e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports